
import { PDFDocument } from 'pdf-lib';

import fontkit from '@pdf-lib/fontkit';

import { capitalize, formatTimelineDate } from '../utils.js';

import { fetchUint8Array, drawText, savePDF } from './utils.js';

import { selected } from '../stores/activity-4.js';

import openSansRegular from '../fonts/open-sans-regular.ttf';

import openSansBold from '../fonts/open-sans-bold.ttf';

import template from './activity-4.pdf';

export async function exportPDF( firstName, lastName ) {

  const sansFontBytes = await fetchUint8Array( openSansRegular );
  
  const sansBoldFontBytes = await fetchUint8Array( openSansBold );

  const templateBytes = await fetchUint8Array( template );
  
  const doc = await PDFDocument.load( templateBytes );
  
  doc.registerFontkit( fontkit );

  const sansFont = await doc.embedFont( sansFontBytes );
  
  const sansBoldFont = await doc.embedFont( sansBoldFontBytes );

  const pages = doc.getPages();
  
  pages.forEach( ( page, index ) => {

    const item = selected.value[ index ];

    const date = formatTimelineDate( item );

    drawText( { doc, page, x: 576, y: 18, align: 'top right', text: `${ capitalize( firstName ) } ${ capitalize( lastName ) }`, font: sansFont, size: 20 } );

    drawText( { doc, page, x: 576, y: 46, align: 'top right', text: new Date().toLocaleString().split( ',' )[ 0 ], font: sansFont, size: 12 } );

    let x = 107, y = 172, height = 0;

    ( { y, height } = drawText( { doc, page, x, y, align: 'top left', text: date, font: sansBoldFont, size: 14 } ) );

    ( { y, height } = drawText( { doc, page, x, y: y + height + 3, align: 'top left', text: item.title, font: sansBoldFont, size: 22, lineHeight: 24, maxWidth: 350 } ) );

    ( { y, height } = drawText( { doc, page, x, y: y + height + 12, align: 'top left', text: 'My analysis of the action or event:', font: sansBoldFont, size: 10 } ) );

    ( { y, height } = drawText( { doc, page, x, y: y + height + 12, align: 'top left', text: item.response || 'No response.', font: sansFont, size: 12, lineHeight: 16, maxWidth: 350 } ) );

  } );

  doc.setTitle( 'Activity Four' );
  
  doc.setSubject( 'Lewis Mountain' );
  
  doc.setCreator( 'Shenandoah National Park' );
    
  doc.setAuthor( 'National Park Service' );

  doc.setProducer( 'PDF-LIB (https://github.com/Hopding/pdf-lib)' );
  
  doc.setCreationDate( new Date() );
  
  doc.setModificationDate( new Date() );
  
  savePDF( `Lewis-Mountain-Activity-4-${ capitalize( firstName ) }-${ capitalize( lastName ) }`, doc );
  
}